import { jsx as _jsx } from "react/jsx-runtime";
import Input from '@helsenorge/designsystem-react/components/Input';
const BasicInput = props => {
    return (_jsx(Input, { name: "query", "aria-label": props.inputAriaLabel, value: props.query, 
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus: props.autoFocus, onChange: e => props.onChange(e.currentTarget.value), size: props.size === 'large' ? 'large' : 'normal', type: "search" }));
};
export default BasicInput;
